import { render, staticRenderFns } from "./DaysHighlight.vue?vue&type=template&id=1bfe64e8&"
import script from "./DaysHighlight.vue?vue&type=script&lang=js&"
export * from "./DaysHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/neuronet/projekty/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfe64e8')) {
      api.createRecord('1bfe64e8', component.options)
    } else {
      api.reload('1bfe64e8', component.options)
    }
    module.hot.accept("./DaysHighlight.vue?vue&type=template&id=1bfe64e8&", function () {
      api.rerender('1bfe64e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/DaysHighlight.vue"
export default component.exports